<!--
 * @Author: gaozexiong RJgaozexiong@ruijie.com.cn
 * @Date: 2022-09-26 15:00:15
 * @LastEditors: gaozexiong RJgaozexiong@ruijie.com.cn
 * @LastEditTime: 2022-09-26 17:14:14
 * @FilePath: \ces-vue-serve\src\shutDown.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="shutDown">
    <img class="bander" src="/shutDown.png" alt="">
    <div class="content">
      <p class="content_f">
        {{ queryData.msg }}
      </p>
      <p class="content_s">
        <span>维护时间：</span>
        <span>{{ queryData.startTime }}</span>
        <span> - </span>
        <span>{{ queryData.endTime }}</span>
      </p>
      <p class="content_t">
        如需帮助请联系 锐捷网络-信息资源部-申鹏
      </p>
      <div class="content_f">
        <div class="content_f_left">
          <img src="/icon_tel.png" alt="">
          <span>17090090517</span>
        </div>
        <div class="content_f_right">
          <img src="/icon_email.png" alt="">
          <span>shenpeng@ruijie.com.cn</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    queryData () {
      return this.$route.query;
    }
  }
};
</script>

<style lang="scss">
  .shutDown{
    position: relative;
    width: 100%;
    height: 100%;
    .bander{
      position: absolute;
      display: block;
      width: 35%;
      height: 50%;
      margin: auto;
      top: 0;
      left: 0;
      right: 0;
      bottom: 30%;
    }
    .content{
      position: absolute;
      bottom: 33%;
      width: 100%;
      font-family: Microsoft YaHei;
      height: 21px;
      font-size: 20px;
       text-align: center;
      .content_s{
        height: 22px;
        font-size: 22px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #424C57;
        line-height: 40px;
        margin-top:30px ;
      }
      .content_t{
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #424C57;
        line-height: 100px;
        letter-spacing:2px;
      }
      .content_f{
        width: 100%;
        height: 20px;
        .content_f_left{
        width: 50%;
        text-align: right;
        height: 20px;
        line-height: 20px;
        float: left;
          img{
            display: inline-block;
            width:18px;
            height: 18px;
            margin-right: 10px;
          }
          span{
            display: inline-block;
            height: 18px;
            font-size: 18px;
            margin-right: 100px;
          }
        }
        .content_f_right{
        width: 50%;
        text-align: left;
        height: 20px;
        line-height: 20px;
        float: left;
          img{
            display: inline-block;
            width:18px;
            height: 18px;
            margin-left: 20px;
             margin-right: 10px;
          }
          span{
            display: inline-block;
            height: 18px;
            font-size: 18px;

          }
        }
      }
    }
  }
</style>
